export enum DocumentSaveState {
    SAVED,
    PENDING
}
